import * as Sentry from '@sentry/react'

import { User } from './api/user/types'
import { prettyFullName } from './utils/name'

Sentry.init({
  // Always enable Sentry for testing purposes
  enabled: (import.meta.env.VITE_ENV !== 'dev' && import.meta.env.VITE_ENV !== 'local') || true,
  environment: import.meta.env.VITE_ENV || 'dev',
  dsn: 'https://9d13069ed65432fca001c40a16a6a5da@o4505407742738432.ingest.us.sentry.io/4509126268747776',
  replaysSessionSampleRate: import.meta.env.VITE_ENV === 'prod' ? 1.0 : 0,
  replaysOnErrorSampleRate: import.meta.env.VITE_ENV === 'prod' ? 1.0 : 0,
  integrations: [Sentry.captureConsoleIntegration(), Sentry.replayIntegration(), Sentry.zodErrorsIntegration()],
  beforeSend(event) {
    if (event.level === 'error' || event.level === 'fatal') {
      return event
    }
    return null
  },
})

export const setSentryUser = (user: User | null, shopName: string | null) => {
  if (user) {
    Sentry.setUser({
      id: user.id,
      email: user.email || undefined,
      username: prettyFullName(user.first_name, user.last_name) || undefined,
      role: user.role,
      shop_name: shopName || undefined,
    })
  } else {
    // Clear user data when logged out
    Sentry.setUser(null)
  }
}
